import React, { Component } from 'react'
import '../stylesheets/main.scss'
import '../stylesheets/components/card.scss';
import link from './Tags';

class Card extends Component{

	render(){
		const isVideo = this.props.video;
		let image;
		let action;
		const cover = this.props.cover;
		const resume = this.props.resume;
		const url = this.props.url;

		if(isVideo === 1){
			image = <iframe src={ cover } allowFullScreen="" className="c-card__img" frameBorder="0" title={ resume } ></iframe>;
			action = <div></div>;
		}
		else
		{
			image = <img className="c-card__img" src={ cover } alt={ resume } />;
			action = <div className="c-card__action" ><a href={ url } className="c-title c-title--color-white c-title--weight-bold c-title--size-small o-uppercase" onClick={ (e) => { link({tagaction: "diario-bordo", tagtitle: resume }, e) } } target="_blank" rel="noreferrer noopener" >Ver Completo ></a></div>;
		}

		return (
				<li className="c-card" key={ this.props.id }>
					{ image }

					<div className="c-card__body" >
						<p className="c-title c-title--color-white c-title--weight-bold c-title--size-medium c-title--lineheight-2">{ resume }</p>
						<br />
					</div>
					
					{ action }
					
				</li>
		)
	}

}

export default Card


// WEBPACK FOOTER //
// ./src/components/Card.js